import React from 'react'
import { useCart } from '../context/CartContext'

const Products = () => {
 const { addToCart } = useCart()

 const products = [
 {
 id:1,
 name: '经典巧克力蛋糕',
 price:198,
 description: '浓郁巧克力风味，丝滑奶油，经典之选',
 image: 'https://images.pexels.com/photos/291528/pexels-photo-291528.jpeg'
},
 {
 id:2,
 name: '草莓奶油蛋糕',
 price:168,
 description: '新鲜草莓搭配轻盈奶油，清新甜美',
 image: 'https://images.pexels.com/photos/1120464/pexels-photo-1120464.jpeg'
 },
 {
 id:3,
 name: '抹茶慕斯蛋糕',
 price:228,
 description: '日式抹茶风味，细腻慕斯口感',
 image: 'https://images.pexels.com/photos/410999/pexels-photo-410999.jpeg'
 },
 {
 id:4,
 name: '红丝绒蛋糕',
 price:188,
 description: '经典红丝绒，浓郁奶酪霜',
 image: 'https://images.pexels.com/photos/1055272/pexels-photo-1055272.jpeg'
 },
 {
 id:5,
 name: '水果千层蛋糕',
 price:158,
 description: '多层薄饼夹新鲜水果，口感丰富',
 image: 'https://images.pexels.com/photos/827513/pexels-photo-827513.jpeg'
 },
 {
 id:6,
 name: '提拉米苏',
 price:178,
 description: '意式经典，咖啡与马斯卡彭的完美结合',
 image: 'https://images.pexels.com/photos/1775285/pexels-photo-1775285.jpeg'
 }
 ]

 return (
 <section id="products" className="section">
 <div className="container">
 <h2 className="section-title">精选蛋糕</h2>
 <p className="section-subtitle">
每一款蛋糕都经过精心制作，选用优质原料，为您带来最纯正的甜蜜体验 </p>
 <div className="grid grid-3">
 {products.map(product => (
 <div key={product.id} className="card">
 <div style={{
 width: '100%',
 height: '200px',
 background: `linear-gradient(135deg, rgba(255,107,139,0.1), rgba(139,92,246,0.1))`,
 borderRadius: '12px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 marginBottom: '16px',
 fontSize: '48px'
 }}>
 🍰 </div>
 <h3 style={{
 fontSize: '1.25rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
 {product.name}
 </h3>
 <p style={{
 color: 'var(--text-light)',
 fontSize: '0.875rem',
 marginBottom: '16px',
 lineHeight: '1.5'
 }}>
 {product.description}
 </p>
 <div style={{
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'space-between'
 }}>
 <span style={{
 fontSize: '1.5rem',
 fontWeight: '700',
 color: 'var(--primary)'
 }}>
 ¥{product.price}
 </span>
 <button onClick={() => addToCart(product)}
 className="btn btn-primary"
 style={{ padding: '8px 16px', fontSize: '14px' }}
 >
加入购物车 </button>
 </div>
 </div>
 ))}
 </div>
 </div>
 </section>
 )
}

export default Products